import { Suspense, lazy } from "react";
import { useIsTripCreated } from "../hooks/useTripURL";
import { TripSearchBarSkeleton } from "./TripSearchBarSkeleton";

const ImportBar = lazy(() => import("./TripSearchBar"));

export function LazyTripSearchBar() {
  const isTripCreated = useIsTripCreated();
  if (!isTripCreated) return null;
  return (
    <Suspense fallback={<TripSearchBarSkeleton />}>
      <ImportBar />
    </Suspense>
  );
}
